export const EXPORT_FORM_TO_PDF_REQUEST = 'EXPORT_FORM_TO_PDF_REQUEST';
export const EXPORT_FORM_TO_PDF_SUCCESS = 'EXPORT_FORM_TO_PDF_SUCCESS';
export const EXPORT_FORM_TO_PDF_ERROR = 'EXPORT_FORM_TO_PDF_ERROR';

export const GET_ALL_BRANCH = 'GET_ALL_BRANCH';
export const GET_ALL_DIVISION = 'GET_ALL_DIVISION';
